import React from "react";
import { Link } from "react-router-dom";
import { Avatar, AvatarImage } from "../../../components/ui/avatar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../components/ui/tooltip";
import { RepositoryViewModel } from "../types";

interface RepositoryPrimaryInfoProps {
  repository: RepositoryViewModel;
}

const RepositoryPrimaryInfo = ({ repository }: RepositoryPrimaryInfoProps) => {
  return (
    <div className="flex min-w-0 items-start gap-3">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to={repository.ownerUrl}
              target="_blank"
              onClick={(event) => event.stopPropagation()}
            >
              <Avatar className="h-9 w-9">
                <AvatarImage src={repository.avatar || undefined} alt={repository.owner} />
              </Avatar>
            </Link>
          </TooltipTrigger>
          <TooltipContent>{repository.owner}</TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <div className="min-w-0 space-y-1">
        <p className="truncate text-sm font-medium">
          {repository.owner}/{repository.name}
        </p>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <p className="line-clamp-2 text-xs text-muted-foreground">
                {repository.description || "No repository description."}
              </p>
            </TooltipTrigger>
            <TooltipContent className="max-w-[380px]">
              {repository.description || "No repository description."}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};

export default RepositoryPrimaryInfo;
